import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';
import type { Promotion } from '@/lib/database.types';

export function MisPromos() {
  const { user } = useAuth();
  const [promos, setPromos] = useState<Promotion[]>([]);

  useEffect(() => {
    if (!user) { setPromos([]); return; }
    void (async () => {
      const { data } = await supabase
        .from('promotions')
        .select('*')
        .eq('client_id', user.id)
        .eq('is_active', true)
        .order('created_at', { ascending: false });
      setPromos(data ?? []);
    })();
  }, [user]);

  if (!user || promos.length === 0) return null;

  return (
    <section id="misPromos">
      <div className="wrap">
        <div className="promos-header reveal">
          <span className="eyebrow" style={{ marginBottom: 0 }}>Exclusivo para ti</span>
          <h2>TUS PROMOCIONES</h2>
        </div>
        <div className="promos-grid">
          {promos.map((p) => (
            <div key={p.id} className="promo-card">
              <h3>{p.titulo}</h3>
              {p.descripcion && <p>{p.descripcion}</p>}
              {p.descuento_pct != null && (
                <p style={{ marginTop: 8 }}>
                  <strong style={{ color: 'var(--orange)', fontFamily: 'var(--fd)', fontSize: '1.4rem', letterSpacing: 2 }}>
                    {p.descuento_pct}% OFF
                  </strong>
                </p>
              )}
              {p.valido_hasta && (
                <div className="pcard-expiry">Vigente hasta {p.valido_hasta}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
